(function () {
  if (window.expCartItemCount !== undefined) return;
  if (window.expCartInit !== undefined) return;

  window.expCartItemCount = null;
  window.expCartInit = false;
  var old_cart = [];

  window.CartJS.getCart().then(function (cart) {
    if (window.expCartInit) return;
    old_cart = cart.items;
    window.expCartItemCount = cart.item_count;
    window.expCartInit = true;
    window.oldCart = old_cart
  });
  window.jQuery(document).on('cart.requestComplete', function(event, cart) {
    if (window.expCartInit) {
      var action_item = {};
      if (cart.item_count == window.expCartItemCount) return;
      var action = 'add';
      if (cart.item_count < window.expCartItemCount) {
        action = 'remove';
      }

      if (action === 'add') {
        cart.items.forEach(function (item) {
          var ok = false;
          old_cart.forEach(function (new_item) {
            if (item.id === new_item.id && item.quantity === new_item.quantity) {
              ok = true;
            }
          });

          if (!ok) action_item = item;
        });
      } else {
        old_cart.forEach(function (item) {
          var ok = false;
          cart.items.forEach(function (new_item) {
            if (item.id === new_item.id && item.quantity === new_item.quantity) {
              ok = true;
            }
          });

          if (!ok) action_item = item;
        });
      }

      var items = [];
      cart.items.forEach(function (item) {
        items.push({
          discounted_price: item.discounted_price / 100,
          handle: item.handle,
          id: item.id,
          image: item.image,
          key: item.key,
          line_price: item.line_price / 100,
          original_line_price: item.original_line_price / 100,
          original_price: item.original_price / 100,
          price: item.price / 100,
          product_id: item.product_id,
          product_title: item.product_title,
          product_type: item.product_type,
          quantity: item.quantity,
          requires_shipping: item.requires_shipping,
          sku: item.sku,
          taxable: item.taxable,
          title: item.title,
          total_discount: item.total_discount,
          url: item.url,
          variant_id: item.variant_id,
          variant_title: item.variant_title,
          option1: item.variant_options[0],
          option2: item.variant_options[1],
        });
      });

      $.get('/products/' + action_item.handle + '?view=meta.json', function (data) {
        data = JSON.parse(data);

        var obj = {
          discounted_price: action_item.discounted_price / 100,
          handle: action_item.handle,
          id: action_item.id,
          image: action_item.image,
          key: action_item.key,
          line_price: action_item.line_price / 100,
          original_line_price: action_item.original_line_price / 100,
          original_price: action_item.original_price / 100,
          price: action_item.price / 100,
          product_id: action_item.product_id,
          product_title: action_item.product_title,
          product_type: action_item.product_type,
          requires_shipping: action_item.requires_shipping,
          sku: action_item.sku,
          taxable: action_item.taxable,
          title: action_item.title,
          url: action_item.url,
          variant_id: action_item.variant_id,
          variant_title: action_item.variant_title,
          option1: action_item.variant_options[0],
          option2: action_item.variant_options[1],
          action: action,
          action_source: (action_item.properties.cart_up_sell) ? 'cart_up_sell' : (action_item.properties.pin_to_cart) ? 'pin_to_cart' : (action_item.properties.add_to_cart) ? 'add_to_cart' : '',
          // sample pin to buy
          // action_source: (action_item.properties && action_item.properties.pin_to_buy) ? 'pin_to_buy' : '',
          // action_source: 'something anything',
          currency: cart.currency,
          item_count: cart.item_count,
          original_total_price: cart.original_total_price / 100,
          total_price: cart.total_price / 100,
          total_discount: cart.total_discount / 100,
          token: cart.token,
          items: items,
          item_category_generc: '',
          item_gender: '',
          item_material: '',
          item_style: ''
        };

        for (var i = 0, len = data.product.tags.length; i < len; i++) {
          var tag = data.product.tags[i];

          if (tag.indexOf('cat:') !== -1) {
            obj.item_category_generc = tag.split('cat:')[1];
          }
          if (tag.indexOf('gender:') !== -1) {
            obj.item_gender = tag.split('gender:')[1];
          }
          if (tag.indexOf('material:') !== -1) {
            obj.item_material = tag.split('material:')[1];
          }
          if (tag.indexOf('style:') !== -1) {
            obj.item_style = tag.split('style:')[1];
          }
        };

        ///exponea.track('cart_update', obj);
      });

      // Commented out to prevent mini-cart refresh on item remove action
      // setTimeout(() => {
      //   if (action === 'remove') {
      //     window.location.reload()
      //   }
      // }, 250);

      old_cart = cart.items;
      window.expCartItemCount = cart.item_count;
    } else {
      // no cart_init
    }
  });
})(window);
